import { createFileRoute } from "@tanstack/react-router";

import { ImportPage } from "../../../../features/catalog/import-page";

export const Route = createFileRoute("/_app/catalog/import/")({ component: ImportPage });
